import { metersToMm } from "@buildwithflux/shared";
import { vec2 } from "../../../../../common";
const flipY = (p) => ({ x: p.x, y: -p.y });
const scaleMms = (p) => ({ x: metersToMm(p.x), y: metersToMm(p.y) });
function translateRotatePoly(poly, by, rot) {
    return poly.map((v) => vec2.chain(v).rotate(rot).add(by).xy());
}
export function toKicadPolygon(poly, translation, rotation) {
    return {
        pts: translateRotatePoly(poly, translation, rotation.z).map(flipY).map(scaleMms),
    };
}
//# sourceMappingURL=polygonHelpers.js.map